import { render, staticRenderFns } from "./PersonasTabACL.vue?vue&type=template&id=1ca6a676"
import script from "./PersonasTabACL.vue?vue&type=script&lang=js"
export * from "./PersonasTabACL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports